import {MobiPointsQueueEventAbstractEvent, EVENT_TYPE_START_TRACK} from "@/mobipoints/queue/event/abstract_event.type";

export class MobiPointsQueueEventTypeStartTrackEvent extends MobiPointsQueueEventAbstractEvent
{
	getEventType(): string {
		return EVENT_TYPE_START_TRACK;
	}

}